import { useEffect, useState } from 'react';
import { contract } from '../lib';

// Live Gen0 price ladder, read from the Genesis contract (tierEnds / tierUsd / requested / quote). Refreshes every 20s.
export function ladderFrom(ends, usd, requested, maxSupply) {
  const tiers = ends.map((end, i) => ({ i, start: i ? ends[i - 1] : 0, end, usd: usd[i] }));
  const cur = tiers.find((t) => requested < t.end) || null; // null = sold out
  const next = cur ? tiers[cur.i + 1] || null : null;
  const leftInTier = cur ? cur.end - requested : 0;
  const tierSize = cur ? cur.end - cur.start : 1;
  const soldPct = cur ? (requested - cur.start) / tierSize : 1; // share of the current tier already minted
  const urgency = !cur ? 'out' : soldPct >= 0.95 ? 'critical' : soldPct >= 0.8 ? 'hot' : soldPct >= 0.5 ? 'warm' : 'calm';
  return { tiers, cur, next, leftInTier, soldPct, urgency, requested, maxSupply };
}

export default function useTiers(nonce) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      const g = contract('Genesis');
      const n = Number(await g.tierCount());
      const idx = Array.from({ length: n }, (_, i) => i);
      const [ends, usd, requested, maxSupply] = await Promise.all([
        Promise.all(idx.map((i) => g.tierEnds(i))), Promise.all(idx.map((i) => g.tierUsd(i))), g.requested(), g.maxSupply()]);
      const L = ladderFrom(ends.map(Number), usd.map((u) => Number(u / 10n ** 16n) / 100), Number(requested), Number(maxSupply));
      let curBnb = null; let nextBnb = null;
      if (L.cur) {
        try { [curBnb, nextBnb] = await Promise.all([g.usdToWei(usd[L.cur.i]), L.next ? g.usdToWei(usd[L.next.i]) : null]); } catch (_) { /* stale feed */ }
      }
      if (alive) setData({ ...L, curBnb, nextBnb, at: Date.now() });
    };
    load().catch(() => {});
    const t = setInterval(() => load().catch(() => {}), 20000);
    return () => { alive = false; clearInterval(t); };
  }, [nonce]);
  return data;
}
